import { Badge, Tooltip, Progress } from 'antd';

interface Props {
  score: number;
  showProgress?: boolean;
  size?: 'small' | 'default';
}

function getScoreColor(score: number): string {
  if (score >= 80) return '#52c41a'; // green
  if (score >= 60) return '#faad14'; // gold
  if (score >= 40) return '#fa8c16'; // orange
  return '#f5222d'; // red
}

function getScoreLabel(score: number): string {
  if (score >= 80) return 'Excellent';
  if (score >= 60) return 'Good';
  if (score >= 40) return 'Fair';
  return 'Poor';
}

export function QualityScoreBadge({ score, showProgress = false, size = 'default' }: Props) {
  const roundedScore = Math.round(score);
  const color = getScoreColor(score);
  const label = getScoreLabel(score);

  if (showProgress) {
    return (
      <Tooltip title={`Quality Score: ${roundedScore}/100 (${label})`}>
        <Progress
          type="circle"
          percent={roundedScore}
          size={size === 'small' ? 40 : 60}
          strokeColor={color}
          format={(percent) => `${percent}`}
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={`Data Quality: ${label}`}>
      <Badge
        count={roundedScore}
        color={color}
        showZero
        overflowCount={100}
        style={{
          fontSize: size === 'small' ? '11px' : '12px',
        }}
      />
    </Tooltip>
  );
}
